import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./app/routes";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider } from "./context/NotificationContext";
import { Toaster } from "react-hot-toast";
import ErrorBoundary from "./components/common/ErrorBoundary";
import { validateFrontendEnv } from "./utils/env";

validateFrontendEnv();

const App = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              fontSize: "14px",
              borderRadius: "8px",
              background: "#ffffff",
              color: "#334155",
              border: "1px solid #E2E8F0",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05)",
            },
            success: {
              style: {
                borderLeft: "4px solid #15BBAE",
              },
              iconTheme: {
                primary: "#15BBAE",
                secondary: "#ffffff",
              },
            },
            error: {
              style: {
                borderLeft: "4px solid #D96F91",
              },
              iconTheme: {
                primary: "#D96F91",
                secondary: "#ffffff",
              },
            },
          }}
        />
        <AuthProvider>
          <ErrorBoundary>
            <NotificationProvider>
              <AppRoutes />
            </NotificationProvider>
          </ErrorBoundary>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default App;
